import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Chip,
  Alert,
  Autocomplete,
  TablePagination,
  FormControlLabel,
  Checkbox,
  FormLabel,
  Divider,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';
import { useRelatoriosDashService } from '../../../../../../use-cases/relatorios-dash';
import { useAppSelector } from '../../../../../../presentation/hooks/store-hooks';
import { IRelatorioSinteticoQuantitativoRequest, FileType } from '../../../../../../application/models/IRelatorioDash';
import { useClientesService } from '../../../../../../use-cases/clientes';
import { useProdutoService } from '../../../../../../use-cases/produto';
import { useTipoConsumoService } from '../../../../../../use-cases/tipo-consumo';
import { useUsuariosService } from '../../../../../../use-cases/usuarios';
import { IClienteTable, IProduto, ITipoUsuario, IUsuarioTable } from '../../../../../../application/models';
import { getMensagemDisponibilidadeRelatorios } from '../../../../../../utils';
import { formatarNumero, formatarData } from '../../../../../../utils/formatters';

export const RelatorioSinteticoQuantitativo = () => {
  const [formData, setFormData] = useState<IRelatorioSinteticoQuantitativoRequest>({
    tipoRelatorio: 'sintetico',
    IDPRODUTO: 0,
    IDCLIENTE: 0,
    IDUSUARIO: 0,
    IDUSUARIO_VENDEDOR: 0,
    TIPOCONSUMO: 0,
    DATAINICIO: '',
    DATAFIM: '',
    generateFiles: false,
    format: FileType.XLSX,
    customTitle: '',
    customSubtitle: '',
    includeTotal: true,
    totalLabel: 'Total de Registros'
  });

  // Estados para os seletores
  const [clienteSelecionado, setClienteSelecionado] = useState<IClienteTable | null>(null);
  const [produtoSelecionado, setProdutoSelecionado] = useState<IProduto | null>(null);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState<IUsuarioTable | null>(null);
  const [usuarioVendedorSelecionado, setUsuarioVendedorSelecionado] = useState<IUsuarioTable | null>(null);
  const [tiposConsumoSelecionados, setTiposConsumoSelecionados] = useState<number[]>([]);
  const [dataInicio, setDataInicio] = useState<Date | null>(null);
  const [dataFim, setDataFim] = useState<Date | null>(null);


  // Estados para busca de clientes
  const [filtroBusca, setFiltroBusca] = useState('');
  const [clientesFiltrados, setClientesFiltrados] = useState<IClienteTable[]>([]);
  const [carregandoClientes, setCarregandoClientes] = useState(false);
  const [dataInicioError, setDataInicioError] = useState<string | null>(null);
  const [dataFimError, setDataFimError] = useState<string | null>(null);

  // Serviços
  const {
    getRelatorioSyntetic,
    getRelatorioQuantitative,
    ordenarColunasRelatorio,
    calcularTotalQuantidadeRelatorio,
    downloadArquivoRelatorio
  } = useRelatoriosDashService();
  const { setClientesPagination, buscarClientes: buscarClientesService } = useClientesService();
  const { setAllProdutosAndTipoConsumo } = useTipoConsumoService();
  const { setUsuarios, setClienteSelecionado: setClienteSelecionadoRedux, setResetClienteSelecionado } = useUsuariosService();
  const { currentUser } = useAppSelector((state: any) => state.user);

  const isDemais = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_DEMAIS;
  const isTecnologiaDaInformacao = currentUser?.IdVelesPerfilInterno === ITipoUsuario.TECNOLOGIA_DA_INFORMACAO;
  const isComercial = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_COMERCIAL;
  const isSupervisorComercial = currentUser?.IdVelesPerfilInterno === ITipoUsuario.VELES_SUPERVISOR_COMERCIAL;
  const isCX = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_EXPERIENCIA_DO_CLIENTE;
  const isCliente = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_CLIENTE;

  // Estados do Redux
  const { produtosTipoConsumo } = useAppSelector((state: any) => state.produto);
  const { usuarios, clienteSelecionado: clienteRedux } = useAppSelector((state: any) => state.usuarios);
  const lastFetchedClienteIdRef = useRef<number | null>(null);
  const previousTipoRelatorioRef = useRef<string | null>(null);

  // Estados de loading e dados
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState<any[]>([]);
  const [erro, setErro] = useState<string | null>(null);
  const [sucesso, setSucesso] = useState<string | null>(null);
  const [aviso, setAviso] = useState<string | null>(null);
  const [arquivosGerados, setArquivosGerados] = useState<any[]>([]);

  // Estados de paginação da tabela
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    if (currentUser) {
      setAllProdutosAndTipoConsumo();

      setClientesPagination({
        limit: 50,
        page: 1
      });

      if (isCliente) {
        buscarClientes('');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, setAllProdutosAndTipoConsumo, isCliente, setClientesPagination]);

  useEffect(() => {
    if (produtosTipoConsumo && produtosTipoConsumo.length > 0) {
    }
  }, [produtosTipoConsumo]);

  useEffect(() => {
    if (isCliente && !clienteSelecionado) {
      if (clienteRedux) {
        setClienteSelecionado(clienteRedux);
        setClientesFiltrados([clienteRedux]);
      } else {
        buscarClientes('');
      }
    } else if (isCliente && clientesFiltrados.length > 0) {
      const clienteDoUsuario = clientesFiltrados.find(c => Number(c.IdCliente) === Number(currentUser?.IdCliente)) || clientesFiltrados[0];
      if (clienteDoUsuario && (!clienteSelecionado || clienteSelecionado.IdCliente !== clienteDoUsuario.IdCliente)) {
        setClienteSelecionado(clienteDoUsuario);
      }
    }
  }, [isCliente, clientesFiltrados, clienteSelecionado, clienteRedux, currentUser?.IdCliente]);

  useEffect(() => {
    if (previousTipoRelatorioRef.current !== null && previousTipoRelatorioRef.current !== formData.tipoRelatorio) {
      setDados([]);
      setArquivosGerados([]);
      setErro(null);
      setSucesso(null);
      setAviso(null);
      setPage(0);
    }
    previousTipoRelatorioRef.current = formData.tipoRelatorio;
  }, [formData.tipoRelatorio]);

  // Função para buscar clientes no backend
  const buscarClientes = async (termoBusca: string) => {
    if (!currentUser) return;

    if (isCliente && clienteSelecionado && termoBusca === '') {
      return;
    }

    setCarregandoClientes(true);

    try {
      let searchIdVendedor = 0;
      let searchIdCliente = 0;

      if (isComercial) {
        searchIdVendedor = currentUser.IdUsuario;
      }

      if (isCliente) {
        searchIdCliente = currentUser.IdCliente;
      }

      const clientes = await buscarClientesService({
        termoBusca,
        IdCliente: searchIdCliente,
        IdUsuario: Number(currentUser.IdUsuario),
        IdVendedor: searchIdVendedor,
        page: 1,
        limit: 50
      });

      if (clientes && clientes.length > 0) {
        setClientesFiltrados(clientes);

        if (isCliente) {
          const clienteDoUsuario = clientes.find(c => Number(c.IdCliente) === Number(currentUser.IdCliente)) || clientes[0];
          if (clienteDoUsuario) {
            setClienteSelecionado(clienteDoUsuario);
          }
        }
      } else if (!isCliente) {
        setClientesFiltrados([]);
      }
    } catch (error) {
      if (!isCliente) {
        setClientesFiltrados([]);
      }
    } finally {
      setCarregandoClientes(false);
    }
  };

  useEffect(() => {
    if (!currentUser) return;

    const timer = setTimeout(() => {
      if (filtroBusca.length >= 3 || filtroBusca.length === 0) {
        buscarClientes(filtroBusca);
      }
    }, 500);

    return () => clearTimeout(timer);
    // buscarClientes omitido de propósito: não é memoizado; incluir nas deps faria o efeito rodar a cada render
  }, [filtroBusca, currentUser]);//eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!clienteSelecionado) {
      // Evita manter cliente/usuários globais do cliente anterior
      setResetClienteSelecionado();
      lastFetchedClienteIdRef.current = null;
      return;
    }
    const idCliente = clienteSelecionado.IdCliente;
    if (lastFetchedClienteIdRef.current === idCliente) return;
    lastFetchedClienteIdRef.current = idCliente;
    setClienteSelecionadoRedux({ cliente: clienteSelecionado as any });
    setUsuarios({ idCliente });
  }, [clienteSelecionado, setClienteSelecionadoRedux, setUsuarios, setResetClienteSelecionado]);

  const obterProdutos = () => {

    if (!produtosTipoConsumo || produtosTipoConsumo.length === 0) {
      return [];
    }

    let produtos = produtosTipoConsumo.map((p: any) => p?.produto).filter(Boolean);

    // Se for relatório quantitativo, mostrar apenas o produto IA (IdProduto === 3)
    if (formData.tipoRelatorio === 'quantitativo') {
      produtos = produtos.filter((p: any) => p?.IdProduto === 3);
      // Não incluir "Todos os Produtos" para quantitativo, apenas o produto IA
      return produtos;
    }

    const todosProdutos = {
      IdProduto: 0,
      NomeProduto: 'Todos os Produtos',
      Nome: 'Todos os Produtos',
      Descricao: 'Selecionar todos os produtos disponíveis'
    };

    return [todosProdutos, ...produtos];
  };

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      IDCLIENTE: clienteSelecionado?.IdCliente || 0,
      IDPRODUTO: produtoSelecionado?.IdProduto || 0,
      IDUSUARIO: usuarioSelecionado?.IdUsuario || 0,
      IDUSUARIO_VENDEDOR: usuarioVendedorSelecionado?.IdUsuario || 0,
      TIPOCONSUMO: tiposConsumoSelecionados.length > 0 ? tiposConsumoSelecionados[0] : 0
    }));
  }, [clienteSelecionado, produtoSelecionado, usuarioSelecionado, usuarioVendedorSelecionado, tiposConsumoSelecionados]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const isValidDate = (date: Date | null): boolean => {
      return date instanceof Date && !isNaN(date.getTime());
    };

    const dataToSend = {
      ...formData,
      DATAINICIO: (dataInicio && isValidDate(dataInicio)) ? dataInicio.toISOString().split('T')[0] : '',
      DATAFIM: (dataFim && isValidDate(dataFim)) ? dataFim.toISOString().split('T')[0] : ''
    };

    try {
      setLoading(true);
      setErro(null);
      setSucesso(null);
      setAviso(null);
      setArquivosGerados([]);

      let response;
      if (formData.tipoRelatorio === 'sintetico') {
        response = await getRelatorioSyntetic(dataToSend);
      } else {
        const dataQuantitativo = {
          ...dataToSend,
          IDPRODUTO: dataToSend.IDPRODUTO || 0
        } as any;
        response = await getRelatorioQuantitative(dataQuantitativo);
      }

      if (response.success) {
        const dadosRetornados = response.data?.data || [];
        const count = response.data?.count?.[0]?.RowNumber || 0;

        setDados(dadosRetornados);
        setPage(0);

        // Verificar se há dados antes de mostrar mensagem de sucesso
        if (dadosRetornados.length > 0 && count > 0) {
          if (response.data?.files && response.data.files.length > 0) {
            setArquivosGerados(response.data.files);
            setSucesso(`Relatório ${formData.tipoRelatorio} gerado com sucesso! ${formatarNumero(count)} registros encontrados. ${formatarNumero(response.data.files.length)} arquivo(s) gerado(s).`);
          } else {
            setArquivosGerados([]);
            setSucesso(`Relatório ${formData.tipoRelatorio} gerado com sucesso! ${formatarNumero(count)} registros encontrados.`);
          }
        } else {
          // Mostrar aviso quando não há dados
          setArquivosGerados([]);
          setAviso('Nenhum dado encontrado para os filtros selecionados. Por favor, ajuste os parâmetros da consulta.');
          setSucesso(null);
        }
      } else {
        setErro(response.error?.message || 'Erro ao gerar relatório');
      }
    } catch (error) {
      setErro('Erro inesperado ao gerar relatório');
      console.error('Erro:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field: keyof IRelatorioSinteticoQuantitativoRequest, value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleTipoRelatorioChange = (event: React.MouseEvent<HTMLElement>, newTipo: 'sintetico' | 'quantitativo' | null) => {
    if (newTipo) {
      setFormData(prev => ({
        ...prev,
        tipoRelatorio: newTipo,
        generateFiles: newTipo === 'quantitativo' ? prev.generateFiles : false
      }));

      if (newTipo === 'quantitativo') {
        const produtoIA = produtosTipoConsumo
          ?.map((p: any) => p?.produto)
          .find((p: any) => p?.IdProduto === 3);

        if (produtoIA) {
          setProdutoSelecionado(produtoIA);
        } else {
          setProdutoSelecionado(null);
        }
        setTiposConsumoSelecionados([]);
        setUsuarioVendedorSelecionado(null);
      } else {
        const todosProdutos = {
          IdProduto: null,
          NomeProduto: 'Todos os Produtos',
          Nome: 'Todos os Produtos',
          Descricao: 'Selecionar todos os produtos disponíveis'
        };

        setProdutoSelecionado(todosProdutos as any);
        setTiposConsumoSelecionados([]);
        setUsuarioVendedorSelecionado(null);
      }
    }
  };

  const limparFormulario = () => {
    setClienteSelecionado(null);
    setProdutoSelecionado(null);
    setUsuarioSelecionado(null);
    setUsuarioVendedorSelecionado(null);
    setTiposConsumoSelecionados([]);
    setDataInicio(null);
    setDataFim(null);
    setFiltroBusca('');
    setClientesFiltrados([]);
    setDados([]);
    setArquivosGerados([]);
    setErro(null);
    setSucesso(null);
    setAviso(null);
    setPage(0);

    setFormData({
      tipoRelatorio: 'sintetico',
      IDPRODUTO: 0,
      IDCLIENTE: isCliente ? (clienteSelecionado?.IdCliente || 0) : 0,
      IDUSUARIO: 0,
      IDUSUARIO_VENDEDOR: 0,
      TIPOCONSUMO: 0,
      DATAINICIO: '',
      DATAFIM: '',
      generateFiles: false,
      format: FileType.XLSX,
      customTitle: '',
      customSubtitle: '',
      includeTotal: true,
      totalLabel: 'Total de Registros'
    });
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getTiposConsumoDoProduto = () => {

    if (!produtoSelecionado || !produtosTipoConsumo) {
      return [];
    }

    const produtoTipoConsumo = produtosTipoConsumo.find((p: any) => p?.produto?.IdProduto === produtoSelecionado.IdProduto);

    return produtoTipoConsumo?.tipoConsumo || [];
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Relatórios Sintéticos e Quantitativos
        </Typography>

        {/* Informativo sobre disponibilidade de dados e permissões */}
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2">
            {getMensagemDisponibilidadeRelatorios()}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            <strong>Permissões:</strong>{' '}
            {(isDemais || isTecnologiaDaInformacao) && 'Você pode gerar relatórios de todos os clientes.'}
            {isComercial && 'Você pode gerar relatórios apenas dos clientes da sua carteira.'}
            {(isSupervisorComercial || isCX) && 'Você pode gerar relatórios dos clientes comerciais (exceto vendedor Veles).'}
            {isCliente && 'Você pode gerar relatórios apenas da sua empresa.'}
          </Typography>
        </Alert>

        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Configuração do Relatório
            </Typography>

            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                {/* Seletor de Tipo de Relatório */}
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <FormLabel component="legend">Tipo de Relatório</FormLabel>
                    <ToggleButtonGroup
                      value={formData.tipoRelatorio}
                      exclusive
                      onChange={handleTipoRelatorioChange}
                      aria-label="tipo de relatório"
                      sx={{ mt: 1 }}
                    >
                      <ToggleButton value="sintetico" aria-label="sintetico">
                        Sintético
                      </ToggleButton>
                      <ToggleButton value="quantitativo" aria-label="quantitativo">
                        Quantitativo (IA Veles)
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </FormControl>
                </Grid>

                {/* Seletor de Cliente */}
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    fullWidth
                    options={clientesFiltrados}
                    getOptionLabel={(option) => {
                      if (!option) return '';
                      if (typeof option === 'string') return option;
                      return `${option.RazaoSocial || option.NomeFantasia || ''} - ${option.CNPJ || ''}`;
                    }}
                    value={clienteSelecionado}
                    onChange={(_, newValue) => {
                      // Sempre limpar state global ao trocar/limpar cliente
                      setResetClienteSelecionado();
                      setClienteSelecionado(newValue);
                      setUsuarioSelecionado(null);
                    }}
                    onInputChange={(_, newInputValue) => setFiltroBusca(newInputValue)}
                    loading={carregandoClientes}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          carregandoClientes
                            ? `Buscando clientes...`
                            : `Cliente * ${clientesFiltrados.length ? `(${formatarNumero(clientesFiltrados.length)} encontrado${clientesFiltrados.length > 1 ? 's' : ''})` : ''}`
                        }
                        placeholder="Digite para buscar por CNPJ, Razão Social, Login ou Nome Fantasia"
                        helperText="Digite pelo menos 3 caracteres para buscar clientes"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {carregandoClientes ? (
                                <Typography variant="caption" color="primary">
                                  Buscando...
                                </Typography>
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box component="li" {...props}>
                        <Box>
                          <Typography variant="body2" fontWeight="bold">
                            {option.RazaoSocial}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {option.NomeFantasia} - {option.CNPJ}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                    isOptionEqualToValue={(option, value) => option?.IdCliente === value?.IdCliente}
                    noOptionsText={
                      carregandoClientes
                        ? "Buscando clientes..."
                        : filtroBusca.length < 3 && filtroBusca.length > 0
                          ? "Digite pelo menos 3 caracteres para buscar"
                          : filtroBusca
                            ? `Nenhum cliente encontrado para "${filtroBusca}"`
                            : "Digite para buscar clientes"
                    }
                    filterOptions={(options) => options}
                    freeSolo={false}
                    selectOnFocus={false}
                    clearOnBlur={false}
                  />
                </Grid>

                {/* Seletor de Produto */}
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    fullWidth
                    options={obterProdutos()}
                    getOptionLabel={(option) => {
                      if (option?.IdProduto === 0) {
                        return 'Todos os Produtos';
                      }
                      return (option as any).Nome || (option as any).NomeProduto || (option as any).Descricao || 'Produto sem nome';
                    }}
                    value={produtoSelecionado}
                    onChange={(_, newValue) => {
                      setProdutoSelecionado(newValue);
                      setTiposConsumoSelecionados([]);
                    }}
                    disabled={formData.tipoRelatorio === 'quantitativo'}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Produto *"
                        placeholder={formData.tipoRelatorio === 'quantitativo' ? 'IA Veles (selecionado automaticamente)' : 'Selecione um produto'}
                        required
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option?.IdProduto === value?.IdProduto}
                    renderOption={(props, option) => (
                      <Box component="li" {...props}>
                        <Box>
                          <Typography variant="body2" fontWeight={option?.IdProduto === 0 ? "bold" : "normal"}>
                            {option?.IdProduto === 0 ? 'Todos os Produtos' : ((option as any).Nome || (option as any).NomeProduto || (option as any).Descricao || 'Produto sem nome')}
                          </Typography>
                          {option?.IdProduto !== 0 && (option as any).Descricao && (
                            <Typography variant="caption" color="text.secondary">
                              {(option as any).Descricao}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    )}
                  />
                </Grid>

                {/* Seletor de Variáveis */}
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    fullWidth
                    multiple
                    options={getTiposConsumoDoProduto()}
                    getOptionLabel={(option) => option?.Descricao || 'Variável'}
                    value={tiposConsumoSelecionados.map(id =>
                      getTiposConsumoDoProduto().find((tipo: any) => tipo?.IdTipoConsumo === id)
                    ).filter(Boolean)}
                    onChange={(event, newValue) => {
                      const ids = newValue.map((tipo: any) => tipo?.IdTipoConsumo).filter(Boolean);
                      setTiposConsumoSelecionados(ids);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={`Variáveis ${getTiposConsumoDoProduto().length ? `(${formatarNumero(getTiposConsumoDoProduto().length)})` : '(Nenhum)'}`}
                        disabled={!produtoSelecionado}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option?.IdTipoConsumo === value?.IdTipoConsumo}
                    disabled={!produtoSelecionado}
                  />
                </Grid>

                {/* Seletor de Usuário */}
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    fullWidth
                    options={usuarios}
                    getOptionLabel={(option) => `${option.Nome} - ${option.Email}`}
                    getOptionKey={(option) => option.IdUsuario}
                    value={usuarioSelecionado}
                    onChange={(_, newValue) => setUsuarioSelecionado(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Usuário"
                        placeholder="Selecione um usuário"
                      />
                    )}
                  />
                </Grid>



                {/* Seletor de Data Início */}
                <Grid item xs={12} md={3}>
                  <DatePicker
                    label="Data Início *"
                    value={dataInicio}
                    onChange={(newValue) => setDataInicio(newValue)}
                    onError={(error) => {
                      if (error === 'minDate') {
                        setDataInicioError('Data não pode ser anterior a 3 meses atrás');
                      } else if (error === 'maxDate') {
                        setDataInicioError('Data não pode ser no futuro');
                      } else if (error === 'invalidDate') {
                        setDataInicioError('Data inválida');
                      } else {
                        setDataInicioError(null);
                      }
                    }}
                    minDate={(() => {
                      const dataLimite = new Date();
                      dataLimite.setMonth(dataLimite.getMonth() - 3);
                      dataLimite.setDate(1);
                      return dataLimite;
                    })()}
                    maxDate={new Date()}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        required: true,
                        error: !!dataInicioError,
                        helperText: dataInicioError
                      }
                    }}
                  />
                </Grid>

                {/* Seletor de Data Fim */}
                <Grid item xs={12} md={3}>
                  <DatePicker
                    label="Data Fim *"
                    value={dataFim}
                    onChange={(newValue) => setDataFim(newValue)}
                    onError={(error) => {
                      if (error === 'minDate') {
                        setDataFimError('Data não pode ser anterior a 3 meses atrás');
                      } else if (error === 'maxDate') {
                        setDataFimError('Data não pode ser no futuro');
                      } else if (error === 'invalidDate') {
                        setDataFimError('Data inválida');
                      } else {
                        setDataFimError(null);
                      }
                    }}
                    minDate={(() => {
                      const dataLimite = new Date();
                      dataLimite.setMonth(dataLimite.getMonth() - 3);
                      dataLimite.setDate(1);
                      return dataLimite;
                    })()}
                    maxDate={new Date()}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        required: true,
                        error: !!dataFimError,
                        helperText: dataFimError
                      }
                    }}
                  />
                </Grid>

                {/* Configurações de Arquivo apenas para Quantitativo */}
                {formData.tipoRelatorio === 'quantitativo' && (
                  <>
                    <Divider sx={{ my: 2, width: '100%' }} />

                    <Grid item xs={12}>
                      <Typography variant="h6" gutterBottom>
                        Configurações de Arquivo
                      </Typography>
                    </Grid>
                  </>
                )}

                {/* Checkbox Gerar Arquivos apenas para Quantitativo */}
                {formData.tipoRelatorio === 'quantitativo' && (
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.generateFiles || false}
                          onChange={(e) => handleInputChange('generateFiles', e.target.checked)}
                        />
                      }
                      label="Gerar Arquivos"
                    />
                  </Grid>
                )}

                {formData.generateFiles && formData.tipoRelatorio === 'quantitativo' && (
                  <>
                    <Grid item xs={12} md={3}>
                      <FormControl fullWidth>
                        <InputLabel>Formato</InputLabel>
                        <Select
                          value={formData.format}
                          onChange={(e) => handleInputChange('format', e.target.value)}
                        >
                          <MenuItem value="csv">CSV</MenuItem>
                          <MenuItem value="xlsx">Excel</MenuItem>
                          <MenuItem value="txt">TXT</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>



                  </>
                )}

                {/* Botões */}
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={loading || !clienteSelecionado || !produtoSelecionado || !dataInicio || !dataFim || !!dataInicioError || !!dataFimError}
                      sx={{ minWidth: 120 }}
                    >
                      {loading ? 'Gerando...' : 'Gerar Relatório'}
                    </Button>
                    <Button
                      type="button"
                      variant="outlined"
                      onClick={limparFormulario}
                      disabled={loading}
                    >
                      Limpar
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>

        {/* Alertas */}
        {erro && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setErro(null)}>
            {erro}
          </Alert>
        )}

        {aviso && (
          <Alert severity="warning" sx={{ mb: 2 }} onClose={() => setAviso(null)}>
            {aviso}
          </Alert>
        )}

        {sucesso && (
          <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSucesso(null)}>
            {sucesso}
          </Alert>
        )}

        {/* Card de Arquivos Gerados */}
        {arquivosGerados.length > 0 && (
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Arquivos Gerados
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {formatarNumero(arquivosGerados.length)} arquivo(s) gerado(s) com sucesso. Clique para baixar:
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {arquivosGerados.map((file, index) => (
                  <Chip
                    key={index}
                    label={`${file.filename} (${file.type.toUpperCase()})`}
                    color="primary"
                    variant="outlined"
                    clickable
                    onClick={async () => {
                      if (file.downloadUrl) {
                        try {
                          await downloadArquivoRelatorio(file);
                        } catch (error) {
                          console.error('Erro ao baixar arquivo:', error);
                          alert('Erro ao baixar o arquivo. Verifique sua conexão ou tente novamente.');
                        }
                      }
                    }}
                  />
                ))}
              </Box>
            </CardContent>
          </Card>
        )}

        {/* Tabela de Resultados */}
        {dados.length > 0 && (
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Resultados do Relatório {formData.tipoRelatorio === 'sintetico' ? 'Sintético' : 'Quantitativo'}
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      {ordenarColunasRelatorio(Object.keys(dados[0]), dados).map((key) => (
                        <TableCell key={key} sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                          {key === 'Descricao' ? 'Variável' : key}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dados
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => (
                        <TableRow key={index}>
                          {ordenarColunasRelatorio(Object.keys(dados[0]), dados).map((key) => {
                            const value = row[key];
                            return (
                              <TableCell key={key}>
                                {typeof value === 'boolean' ? (
                                  <Chip
                                    label={value ? 'Sim' : 'Não'}
                                    color={value ? 'success' : 'default'}
                                    size="small"
                                  />
                                ) : value instanceof Date || (typeof value === 'string' && (/^\d{2}\/\d{2}\/\d{4}/.test(value) || /^\d{4}-\d{2}-\d{2}T/.test(value))) ? (
                                  formatarData(value)
                                ) : typeof value === 'string' ? (
                                  value
                                ) : (
                                  formatarNumero(value)
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))}
                  </TableBody>
                  {formData.tipoRelatorio === 'sintetico' && (() => {
                    const total = calcularTotalQuantidadeRelatorio(dados);
                    if (total <= 0) return null;

                    const colunasOrdenadas = ordenarColunasRelatorio(Object.keys(dados[0]), dados);
                    const totalColunas = colunasOrdenadas.length;

                    const ultimaColuna = colunasOrdenadas[totalColunas - 1];
                    const temValoresNumericosNaUltima = dados.some(row => {
                      const value = row[ultimaColuna];
                      const numValue = typeof value === 'number' ? value : parseFloat(String(value));
                      return !isNaN(numValue) && isFinite(numValue);
                    });

                    if (!temValoresNumericosNaUltima) return null;

                    return (
                      <TableFooter>
                        <TableRow>
                          {colunasOrdenadas.slice(0, Math.max(0, totalColunas - 2)).map((key) => (
                            <TableCell key={key} sx={{ borderTop: 1, borderColor: 'divider' }} />
                          ))}
                          {totalColunas >= 2 && (
                            <TableCell
                              sx={{
                                borderTop: 1,
                                borderColor: 'divider',
                                fontWeight: 'bold',
                                color: 'text.primary'
                              }}
                            >
                              TOTAL:
                            </TableCell>
                          )}
                          <TableCell
                            sx={{
                              borderTop: 1,
                              borderColor: 'divider',
                              fontWeight: 'bold',
                              color: 'text.primary'
                            }}
                          >
                            {total.toLocaleString('pt-BR')}
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    );
                  })()}
                </Table>
              </TableContainer>

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={dados.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Registros por página:"
                  labelDisplayedRows={({ from, to, count }) => `${formatarNumero(from)}-${formatarNumero(to)} de ${formatarNumero(count)}`}
                />
              </Box>
            </CardContent>
          </Card>
        )}
      </Box>
    </LocalizationProvider>
  );
};
